import React, {useState, useEffect} from 'react';
import format from 'date-fns/format';
import parseISO from 'date-fns/parseISO';
import {Modal} from "react-bootstrap";
import Link from "react-router-dom/Link";

// styles
import styles from './classTypes.module.css';

// actions
import {fetchClassTypes, newClassType, removeContentMeta, updateContentMeta} from "../../../store/actions/contentActions";


// components
import {PrimaryButton, PrimaryButtonSm} from "../../buttons/buttons";
import {ReactComponent as TimesIcon} from '../../../images/times-solid.svg';
import {ReactComponent as EditIcon} from '../../../images/icons/edit.svg';
import {BoxContainer} from "../../containers/boxContainer/boxContainer";

const ClassTypes = props => {
    // local
    const [modal, setShowModal] = useState(false);
    const [edit, setEdit] = useState({id: '', name: '', state: 'New'});
    const [types, setTypes] = useState([]);
    const [confirm, setConfirm] = useState(null);

    useEffect(() => {
        loadTypes();
    }, []);

    async function loadTypes() {
        try {
            const res = await fetchClassTypes();
            setTypes(res);
        } catch (e) {
            console.log(e);
        }
    }

    function showModal(id, val) {
        if (val) setEdit({id: id, name: val, state: 'Update'});
        setShowModal(true);
        setConfirm(null);
    }

    function closeModal() {
        setEdit({id: '', name: '', state: 'New'});
        setShowModal(false);
    }

    async function remove(id) {
        if (id !== confirm) {
            setConfirm(id);
            return;
        }
        try {
            await removeContentMeta(id);
            await loadTypes();
        } catch(e) {
            console.log(e);
        }
        setConfirm(null);
        loadTypes();
    }

    async function add() {
        try {
            await newClassType(edit.name);
            loadTypes();
            closeModal();
        } catch (e) {
            console.log(e);
        }
    }

    async function update() {
        try {
            await updateContentMeta(edit.id, edit.name);
            loadTypes();
            closeModal();
        } catch (e) {
            console.log(e);
        }
    }

    function submitUpdate(e) {
        e.preventDefault();
        if (edit.state === 'New') {
            add();
        } else {
            update();
        }
    }
    return (
        <div>
            <div className="page-header-container searchForm-container">
                <div className="container">
                    <div className="row">
                        <div className="col-sm-12">
                            <nav aria-label="breadcrumb ">
                                <ol className="breadcrumb ">
                                    <li className="breadcrumb-item underline ">
                                        <Link to="/dashboard" className="text-light">
                                            Dashboard
                                        </Link>
                                    </li>
                                    <span className="arrow"/>
                                    <li className="breadcrumb-item underline ">
                                        <Link to="/dashboard/Content" className="text-light">
                                            Content
                                        </Link>
                                    </li>
                                    <span className="arrow"/>
                                    <li
                                        className="breadcrumb-item text-light active"
                                        aria-current="page"
                                    >
                                        Class Types
                                    </li>
                                </ol>
                            </nav>
                        </div>
                        <div className="col-sm-12 col-md-6">
                            <h1>Class Types</h1>
                        </div>
                    </div>
                </div>
            </div>

            <div className={`container margin-top-25 ${styles.header}`}>
                <PrimaryButton
                    className={styles.new}
                    onClick={()=>showModal()}>+ New</PrimaryButton>
            </div>

            <div className={'container'}>
                <div className={`${styles.row} ${styles.head}`}>
                    <div className={styles.name}>
                        Name
                    </div>
                    <div className={styles.classes}>
                        Classes
                    </div>
                    <div className={styles.updated}>
                        Updated
                    </div>
                    <div className={styles.buttons}/>
                </div>

                <div>
                    {types.map(type => {
                        return (
                            <div key={type.content_meta_option_id}>
                                <BoxContainer className={styles.row}>
                                    <div className={styles.name}>{type.label}</div>
                                    <div className={styles.classes}>{type.class_count} classes</div>
                                    <div className={styles.updated}>{format(parseISO(type.updated_at), 'MM/dd/yyyy')}</div>
                                    <div className={styles.buttons}>
                                        <EditIcon onClick={() => showModal(type.content_meta_option_id, type.label)}/>
                                        { confirm === type.content_meta_option_id ?
                                            <div className={styles.confirmContainer}>
                                                <button onClick={() => remove(type.content_meta_option_id)} className={styles.confirm}>Confirm</button>
                                                <button onClick={() => setConfirm(null)} className={styles.cancel}>Cancel</button>
                                            </div>
                                            :
                                            <TimesIcon onClick={() => remove(type.content_meta_option_id)}/>
                                        }
                                    </div>
                                </BoxContainer>
                            </div>

                        )
                    })}
                </div>
            </div>

            <Modal show={modal} onHide={closeModal}>
                <BoxContainer className='padding-standard'>
                    <h4>{edit.state} Class Type</h4>
                    <form onSubmit={submitUpdate}>
                        <div className="form-group">
                            <label>Name</label>
                            <input
                                onChange={e=>setEdit({...edit, name: e.target.value})}
                                value={edit.name}
                                type="text"
                                className="form-control"/>
                        </div>
                        <PrimaryButtonSm onClick={submitUpdate}>Submit</PrimaryButtonSm>
                    </form>
                </BoxContainer>
            </Modal>
        </div>
    )
}
export default ClassTypes;